import { useEffect, useState } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsCarBooking';

const EMPTY = {
  idVehiculo: 0,
  idReserva: 0,
  fechaCarga: '',
  litros: '',
  importe: '',
  kmOdometro: '',
  estacion: '',
  notas: '',
};

const endpointVehiculo = ENDPOINTS.vehiculo;
const modeloVehiculo = Models.vehiculo;

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    idVehiculo: '',
    idReserva: '',
    fechaCarga: '',
    litros: '',
    importe: '',
    kmOdometro: '',
    estacion: '',
    notas: '',
  });
  const [vehiculos, setVehiculos] = useState([]);

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'idVehiculo':
        if (!value || Number(value) <= 0) error = 'Selecciona un vehículo.';
        break;
      case 'idReserva':
        if (!value || Number(value) <= 0) error = 'El ID de reserva es obligatorio.';
        break;
      case 'fechaCarga':
        if (!value) error = 'La fecha de carga es obligatoria.';
        break;
      case 'litros':
        if (value === '' || value === null || value === undefined) error = 'Los litros son obligatorios.';
        break;
      case 'importe':
        if (value === '' || value === null || value === undefined) error = 'El importe es obligatorio.';
        break;
      case 'kmOdometro':
        if (value === '' || value === null || value === undefined) error = 'El kilometraje es obligatorio.';
        break;
      case 'estacion':
        if (!value) error = 'La estación es obligatoria.';
        break;
      case 'notas':
        if (!value) error = 'Las notas son obligatorias.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    const fields = ['idVehiculo', 'idReserva', 'fechaCarga', 'litros', 'importe', 'kmOdometro', 'estacion', 'notas'];
    let isValid = true;
    fields.forEach(f => {
      if (!validateField(f, form[f])) isValid = false;
    });
    return isValid;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    const loadVehiculos = async () => {
      try {
        const res = await axios.get(endpointVehiculo);
        setVehiculos((res.data || []).map((x) => modeloVehiculo(x)));
      } catch (e) {
        console.error('Error al cargar vehículos en CombustibleModal', e);
      }
    };
    loadVehiculos();
  }, []);

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idCarga: data.idCarga ?? 0,
        idVehiculo: data.idVehiculo ?? 0,
        idReserva: data.idReserva ?? 0,
        fechaCarga: (data.fechaCarga ?? '').slice(0, 10),
        litros: data.litros ?? '',
        importe: data.importe ?? '',
        kmOdometro: data.kmOdometro ?? '',
        estacion: data.estacion ?? '',
        notas: data.notas ?? '',
      };
      setForm(filled);
      validateField('idVehiculo', filled.idVehiculo);
      validateField('idReserva', filled.idReserva);
      validateField('fechaCarga', filled.fechaCarga);
      validateField('litros', filled.litros);
      validateField('importe', filled.importe);
      validateField('kmOdometro', filled.kmOdometro);
      validateField('estacion', filled.estacion);
      validateField('notas', filled.notas);
    } else {
      setForm(EMPTY);
      setErrors({ idVehiculo: '', idReserva: '', fechaCarga: '', litros: '', importe: '', kmOdometro: '', estacion: '', notas: '' });
    }
  }, [mode, data]);

  if (!open) return null;

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled =
    !form.idVehiculo ||
    !form.idReserva ||
    !form.fechaCarga ||
    form.litros === '' ||
    form.importe === '' ||
    form.kmOdometro === '' ||
    !form.estacion?.trim() ||
    !form.notas?.trim() ||
    hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  // etiqueta amigable del vehículo
  function labelVehiculo(v) {
    if (!v) return '';
    const placa = v.placa || 'S/placa';
    const marca = v.marca || '';
    const modelo = v.modelo || '';
    const anio = v.anio || '';
    const detalle = [marca, modelo, anio].filter(Boolean).join(' ');
    return detalle ? `${placa} · ${detalle}` : placa;
  }

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nueva carga de combustible' : 'Editar carga de combustible'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      {/* Vehículo */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Vehículo:</label>
        <br /><br />
        <select
          className={`infoField${errors.idVehiculo ? ' infoField--error' : ''}`}
          value={form.idVehiculo || 0}
          onChange={(e) => handleChange('idVehiculo', Number(e.target.value) || 0)}
        >
          <option value={0}>-- Selecciona un vehículo --</option>
          {vehiculos.map((v) => (
            <option key={v.idVehiculo} value={v.idVehiculo}>
              {labelVehiculo(v)}
            </option>
          ))}
        </select>
        {errors.idVehiculo && <small style={errorStyle}>{errors.idVehiculo}</small>}
      </div>

      {/* Id Reserva */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Id Reserva:</label>
        <br /><br />
        <input
          className={`infoField${errors.idReserva ? ' infoField--error' : ''}`}
          type="number"
          min={1}
          value={form.idReserva}
          onChange={(e) => handleChange('idReserva', Number(e.target.value) || 0)}
        />
        {errors.idReserva && <small style={errorStyle}>{errors.idReserva}</small>}
      </div>

      {/* Fecha Carga */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Fecha de carga:</label>
        <br /><br />
        <input
          className={`infoField${errors.fechaCarga ? ' infoField--error' : ''}`}
          type="date"
          onKeyDown={(e) => e.preventDefault()}
          value={form.fechaCarga}
          onChange={(e) => handleChange('fechaCarga', e.target.value)}
          onBlur={(e) => validateField('fechaCarga', e.target.value)}
        />
        {errors.fechaCarga && <small style={errorStyle}>{errors.fechaCarga}</small>}
      </div>

      {/* Litros */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Litros:</label>
        <br /><br />
        <input
          className={`infoField${errors.litros ? ' infoField--error' : ''}`}
          type="number"
          step="any"
          value={form.litros}
          onChange={(e) => handleChange('litros', e.target.value)}
        />
        {errors.litros && <small style={errorStyle}>{errors.litros}</small>}
      </div>

      {/* Importe */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Importe:</label>
        <br /><br />
        <input
          className={`infoField${errors.importe ? ' infoField--error' : ''}`}
          type="number"
          step="any"
          value={form.importe}
          onChange={(e) => handleChange('importe', e.target.value)}
        />
        {errors.importe && <small style={errorStyle}>{errors.importe}</small>}
      </div>

      {/* KM Odómetro */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>KM Odómetro:</label>
        <br /><br />
        <input
          className={`infoField${errors.kmOdometro ? ' infoField--error' : ''}`}
          type="number"
          step="any"
          value={form.kmOdometro}
          onChange={(e) => handleChange('kmOdometro', e.target.value)}
        />
        {errors.kmOdometro && <small style={errorStyle}>{errors.kmOdometro}</small>}
      </div>

      {/* Estación */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Estación:</label>
        <br /><br />
        <input
          className={`infoField${errors.estacion ? ' infoField--error' : ''}`}
          value={form.estacion}
          onChange={(e) => handleChange('estacion', e.target.value)}
          maxLength={120}
        />
        {errors.estacion && <small style={errorStyle}>{errors.estacion}</small>}
      </div>

      {/* Notas */}
      <div style={{ gridColumn: '1 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Notas:</label>
        <br /><br />
        <textarea
          className={`infoField${errors.notas ? ' infoField--error' : ''}`}
          value={form.notas}
          onChange={(e) => handleChange('notas', e.target.value)}
          rows={3}
          maxLength={500}
        />
        {errors.notas && <small style={errorStyle}>{errors.notas}</small>}
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
